import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Train of Thought — FTUE demo (3 essais progressifs).
 *
 * Spec : _wiki-source/train-of-thought.md §FTUE
 *   E1 : 1 train, 1 voie ciblée. On clique l'aiguillage pour aligner.
 *   E2 : 2 trains, 2 couleurs.
 *   E3 : 3 trains, vitesse normale.
 *
 * MVP pédagogique : pas d'animation continue. On affiche schématiquement le
 * setup pour expliquer le geste. La session live (staircaseView) gère le
 * vrai timing.
 */
import { useState } from 'react';
const DEMO_STEPS = [
    {
        idx: 1,
        title: 'Essai 1 — un train',
        hint: 'Touche l\'aiguillage pour diriger le train vers la voie de sa couleur.',
        trains: ['red'],
    },
    {
        idx: 2,
        title: 'Essai 2 — deux trains',
        hint: 'Deux couleurs, deux voies. Anticipe le second pendant que le premier roule.',
        trains: ['red', 'blue'],
    },
    {
        idx: 3,
        title: 'Essai 3 — trois trains',
        hint: 'Trois trains à gérer. Regarde plusieurs voies en parallèle.',
        trains: ['red', 'blue', 'green'],
    },
];
const COLOR_HEX = {
    red: '#c0413f',
    blue: '#3a6e9a',
    green: '#5b8a4a',
    yellow: '#d6a949',
    purple: '#7a4f8a',
};
export function Demo({ onComplete, onSkip }) {
    const [stepIdx, setStepIdx] = useState(0);
    const step = DEMO_STEPS[stepIdx];
    const isLast = stepIdx === DEMO_STEPS.length - 1;
    const handleNext = () => {
        if (isLast)
            onComplete();
        else
            setStepIdx((i) => i + 1);
    };
    return (_jsxs("div", { className: "flex flex-1 flex-col items-center gap-s4 py-s4 text-center", children: [_jsx("p", { className: "font-mono text-[9.5px] uppercase tracking-[0.30em] text-cyan-text-faint", children: "D\u00E9mo guid\u00E9e" }), _jsx("h2", { className: "font-display text-[22px] font-medium leading-7 tracking-cy-display text-cyan-text", children: step.title }), _jsx("p", { className: "max-w-[320px] text-[13.5px] text-cyan-text-secondary", children: step.hint }), _jsxs("div", { className: "relative flex flex-col items-center justify-between bg-cyan-network p-s4", style: { width: 260, height: 240 }, children: [_jsx("div", { className: "flex w-full justify-around", children: step.trains.map((color, i) => (_jsx("div", { "aria-hidden": true, className: "h-8 w-12", style: { background: COLOR_HEX[color] } }, i))) }), _jsx("div", { className: "flex w-full justify-around", children: step.trains.map((_, i) => (_jsx("div", { "aria-hidden": true, className: "h-6 w-12 border-2 border-cyan-surface" }, i))) }), _jsx("div", { className: "flex w-full justify-around", children: step.trains.map((color, i) => (_jsx("div", { "aria-hidden": true, className: "h-6 w-14 opacity-70", style: { background: COLOR_HEX[color] } }, i))) })] }), _jsxs("div", { className: "flex flex-col items-stretch gap-s3 self-stretch", children: [_jsx("button", { type: "button", onClick: handleNext, className: "inline-flex h-12 w-full items-center justify-center bg-cyan-core font-display text-[14px] font-medium tracking-[-0.01em] text-cyan-surface transition active:scale-[0.985] hover:bg-cyan-network", children: isLast ? 'Démarrer la session' : 'Essai suivant' }), _jsx("button", { type: "button", onClick: onSkip, className: "text-[12px] text-cyan-text-secondary underline-offset-4 hover:underline", children: "Passer la d\u00E9mo" })] })] }));
}
//# sourceMappingURL=demo.js.map